import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { VehicleService } from 'services/calculator-items/vehicle.service';
import { FooterNavbarService } from 'services/connectors/footer-navbar.service';
import { SpinnerService } from 'services/spinner.service';

@Component({
    selector: 'tpc-car',
    templateUrl: './car.component.html',
    styleUrls: ['./car.component.css']
})
export class CarComponent implements OnInit, OnDestroy {
    // ATTENTION ALL commented data can be used if JE decides to add again option "Can't find your vehicle's make?" to MAKE input
    private nextSub: Subscription;
    private isFormSubmitted = false;

    public carForm: FormGroup;
    public carYearList = [];
    public carMakeList = [];
    public carModelList = [];
    public isCarMakeEmpty: boolean;
    // public userCantFindCarMakeValue = 'unknown';

    constructor(private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.carForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.getYearList();
    }

    private createForm() {
        this.carForm = this.fb.group({
            carYear: ['', Validators.required],
            carMake: ['', Validators.required],
            carModel: ['', Validators.required],
            carMileage: ['', Validators.required],
        });
    }

    private getYearList() {
        // return Array.from({length: new Date().getFullYear() - start + 1}, (v, k) => k + start).reverse();
        this.spinner.show();
        this.vehicleService.getAllYears().subscribe(
            years => {
                this.carYearList = years;
                this.spinner.hide();
            }
        );
    }

    private getMakeList(): void {
        this.spinner.show();
        this.vehicleService.getAllMakers(this.getFV('carYear')).subscribe(
            makers => {
                this.isCarMakeEmpty = makers.length === 0;
                if (makers[0] === '') {
                    makers.splice(0, 1);
                }

                this.carMakeList = makers;
                this.spinner.hide();
            }
        );
    }

    private getModelList(): void {
        this.spinner.show();

        this.vehicleService.getAllModels(this.getFV('carYear'), this.getFV('carMake')).subscribe(
            models => {
                this.carModelList = models;
                this.spinner.hide();
            }
        );
    }

    public onYearChange(): void {
        setTimeout(() => {
            if (this.getFV('carYear') !== '') {
                this.getMakeList();
            } else {
                this.carMakeList = [];
            }
        }, 10);
    }

    public onMakeChange(): void {
        this.carModelList = [];
        // this.resetAllInputsAfterMake();
        setTimeout(() => {
            // if (this.getFV('carMake') === this.userCantFindCarMakeValue) {
            //     this.setAllInputsAfterMAkeValid();
            //     return;
            // } else
            if (this.getFV('carMake') !== '') {
                this.getModelList();
            }
        }, 10);
    }

    // private setAllInputsAfterMAkeValid(): void {
    //     let controls = (<any>this.carForm).controls;
    //     // set any value to make carModel and carMileage fields valid
    //     controls['carModel'].setValue('unknown');
    //     controls['carMileage'].setValue('unknown');
    // }
    //
    // private resetAllInputsAfterMake(): void {
    //     let controls = (<any>this.carForm).controls;
    //     controls['carModel'].reset();
    //     controls['carMileage'].reset();
    // }

    public checkError(param) {
        return this.carForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.carForm.get(param).touched);
    }

    private next(): void {
        this.vehicleService.setLastUnsavedCar(
            this.getFV('carYear'),
            this.getFV('carMake'),
            this.getFV('carModel'),
            this.getFV('carMileage')
        );
        // if (this.getFV('carMake') === this.userCantFindCarMakeValue) {
        //     this.router.navigate(['/individual/vehicle/class']);
        // } else {
            this.router.navigate(['/individual/vehicle/options']);
        // }
    }

    public getFV(param): any {
        return this.carForm.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/car/car.component.ts